<template>
  <div class="form-container">
    <div class="vcore_container pe_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--12 form-container_provider-logo">
          <LogoDisplay v-if="logo" :logo-src="logo"></LogoDisplay>
        </div>

        <div class="vcore_col--xs--12">
          <h2
            class="form-title vcore_col--xs--12"
            tabindex="-1"
            v-focus="lastActivated"
          >
            Financing Information
          </h2>

          <div class="existing_hsfaccount_wrapper vcore_col--xs--12">
            Is there an existing HSF account you would like this expense added
            to?
            <!-- <p></p> -->
          </div>

          <div class="radio-group vcore_col--xs--12">
            <label
              for="existingaccount-yes"
              class="vcore_radio-group radio-group_inline vcore_input-label"
            >
              <input
                type="radio"
                class="vcore_radio-input"
                name="existingaccount"
                id="existingaccount-yes"
                value="true"
                v-model="existingHSFAccountsLocal"
              />
              <span class="vcore_radio-indicator"></span>

              <span class="existingaccount-choice">
                <span>Yes</span>
              </span>
            </label>
            <label
              for="existingaccount-no"
              class="vcore_radio-group radio-group_inline"
            >
              <input
                type="radio"
                class="vcore_radio-input"
                name="existingaccount"
                id="existingaccount-no"
                value="false"
                v-model="existingHSFAccountsLocal"
              />
              <span class="vcore_radio-indicator"></span>

              <span class="existingaccount-choice">
                <span>No</span>
              </span>
            </label>
          </div>
          <CustomError
            class="vcore_col--xs--12 custom_radio_error"
            :error="existingHSFAccountError"
            v-if="!radioChecked"
          />

          <div class="financing-info_margin_wrapper vcore_col--xs--12">
            <p class="financing_details_text">Financing Details</p>
          </div>

          <div class="vcore_col--xs--12 form-description">
            The dollar amount you are requesting for the line of credit. This
            should equal the amount owed on the Healthcare Provider billing
            statement. All fields required.
          </div>

          <div class="vcore_col--xs--12 financing-info_form_wrapper">
            <CustomForm
              ref="financingForm"
              :form="formData.financing"
              :value="formValues.account"
              @input="handleCustomFormInput('account', $event)"
              @valid-change="handleValidChange('financingForm', $event)"
              @errors-change="handleErrorsChange('financingForm', $event)"
            />
          </div>
          <div class="vcore_col--xs--12">
            <h3>Payment Terms</h3>
            <PaymentEstimator
              :total-loan-amount="amountRequested | usdToFloat"
              :terms="selectedProvider.terms"
              :is-fixed-rate="selectedProvider.isFixedRate"
              :fixed-interest-rate="selectedProvider.fixedInterestRate"
              :rate-margin="selectedProvider.rateMargin"
              :step="'Financing Information'"
              readonly
            ></PaymentEstimator>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@Shared/mixins/Form";
import LogoDisplay from "../LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";
import CustomError from "@Shared/components/CustomError";
import FinancingInformationForm from "../../forms/FinancingInformation.json";
import PaymentEstimator from "@Shared/components/PaymentEstimator";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FinancingInformation",
  mixins: [Form],
  data() {
    return {
      radioChecked: true,
      existingHSFAccountError: "This field is required.",
      formData: {
        financing: FinancingInformationForm,
      },
      activeForms: ["financingForm"],
    };
  },
  components: {
    PaymentEstimator,
    LogoDisplay,
    CustomError,
  },
  computed: {
    ...mapGetters([
      "amountRequested",
      "selectedProvider",
      "existingHSFAccount",
    ]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.selectedProvider.customBrandingList
      );
    },

    existingHSFAccountsLocal: {
      get() {
        return this.existingHSFAccount;
      },
      set(value) {
        this.setExistingHSFAccount(value);
        this.setExistingHSFAccountError();
      },
    },
  },

  methods: {
    ...mapActions([
      "setExistingHSFAccount",
      "setFormErrors",
      "saveExistingHSFAccount",
    ]),

    setExistingHSFAccountError() {
      if (this.existingHSFAccount != "") {
        this.radioChecked = true;
      } else {
        this.radioChecked = false;
      }
    },

    updateRadioChecked(val) {
      console.log(val);
    },

    next() {
      if (this.radioChecked) {
        if (this.editFlag) {
          this.$emit("save-step");
          this.saveExistingHSFAccount(this.existingHSFAccount);
        } else {
          this.saveExistingHSFAccount(this.existingHSFAccount);
          this.$emit("next-step");
        }
      }
    },
    previous() {
      this.$emit("prev-step");
    },
    statementImg() {
      return getCustomBrandingByKey(
        KEYS.STATEMENT_IMG,
        this.selectedProvider.customBrandingList
      );
    },
  },
  mounted() {
    // this.$nextTick lets us run the code after child components are loaded
    document.addEventListener("click", this.setExistingHSFAccountError);
    this.$nextTick(function () {
      var statementImg = this.statementImg();

      if (statementImg !== null && statementImg !== "") {
        var elemPAN = document.getElementById("patient-account-number");
        window.myPAN = elemPAN;
        var elemTooltip = elemPAN.parentElement.querySelector(
          ".vcore_popover-content"
        );
        window.myTooltip = elemTooltip;
        var elemImg = document.createElement("img");
        elemImg.src = statementImg;
        elemTooltip.appendChild(elemImg);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
h2 {
  /*font-family: Poppins;*/
  font-weight: 600;
  line-height: 42px;
}

::v-deep h3 {
  font-size: 21px;
  line-height: 25px;
  font-family: "Poppins";
  color: #43454d;
  font-weight: 500;
}

.financing-info_form_wrapper {
  margin-top: 0px;
  margin-bottom: 40px;
}

.existing_hsfaccount_wrapper {
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  color: #43454d;
}

.financing-info_margin_wrapper {
  font-weight: 400;
  margin-top: 40px;
  margin-bottom: 0px;
  font-size: 21px;
  line-height: 23px;
}

.financing_details_text {
  color: #43454d;
  font-family: "Poppins";
  font-size: 21px;
  letter-spacing: 0;
}

.radio-group_inline {
  display: inline;
  padding-left: 5px;
  padding-right: 5px;
}

.existingaccount-choice {
  padding-left: 5px;
  // padding-right: 5px;
}

.custom_radio_error {
  padding-left: 20px;
  padding-right: 8px;
}
</style>
